module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#proofread",
      toString: function () {
        return this.url;
      }
    }